import React, { useEffect, useState } from 'react'

export interface IUseDraggingProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  containerRef: React.RefObject<any>
  onDragEnter?: (event: DragEvent) => void
  onDragOver?: (event: DragEvent) => void
  onDragLeave?: (event: DragEvent) => void
  onDrop?: (event: DragEvent) => void
}

export const useDragging = ({
  containerRef,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
}: IUseDraggingProps) => {
  const [isDragging, setIsDragging] = useState(false)

  const handleDragEnter = (event: DragEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (!event.dataTransfer?.items || !event.dataTransfer.items.length) return

    setIsDragging(true)
    onDragEnter?.(event)
  }

  const handleDragOver = (event: DragEvent) => {
    event.preventDefault()
    event.stopPropagation()

    onDragOver?.(event)
  }

  const handleDragLeave = (event: DragEvent) => {
    event.preventDefault()
    event.stopPropagation()

    setIsDragging(false)
    onDragLeave?.(event)
  }

  const handleDrop = (event: DragEvent) => {
    event.preventDefault()
    event.stopPropagation()
    setIsDragging(false)

    onDrop?.(event)
  }

  useEffect(() => {
    containerRef.current?.addEventListener('dragenter', handleDragEnter)
    containerRef.current?.addEventListener('dragover', handleDragOver)
    containerRef.current?.addEventListener('dragleave', handleDragLeave)
    containerRef.current?.addEventListener('drop', handleDrop)

    return () => {
      containerRef.current?.removeEventListener('dragenter', handleDragEnter)
      containerRef.current?.removeEventListener('dragover', handleDragOver)
      containerRef.current?.removeEventListener('dragleave', handleDragLeave)
      // eslint-disable-next-line react-hooks/exhaustive-deps
      containerRef.current?.removeEventListener('drop', handleDrop)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, onDragEnter, onDragLeave, onDragOver, onDrop])

  return {
    isDragging,
  }
}
